export enum ViewDashboardSecondarySectionBlock {
  Root = 'ViewDashboardSecondarySection',
}

export enum ViewDashboardSecondarySectionElement {
  Title = 'title',
  Content = 'content',
}
